import React from "react";


export class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || "Se produjo un error inesperado." };
  }

  componentDidCatch(error, info) {
    console.error("[route-error-boundary] render crash", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="min-h-screen bg-[#f6f2ea] px-4 py-10" data-testid="route-error-boundary-fallback">
          <div className="mx-auto max-w-2xl rounded-[2rem] border border-[#e5dfd5] bg-white p-8 shadow-[0_20px_80px_rgba(17,17,17,0.05)]">
            <p className="text-xs uppercase tracking-[0.22em] text-[#8b7d6f]">Estado de seguridad</p>
            <h1 className="mt-3 text-3xl font-light tracking-[-0.05em] text-[#1c1917]">No pudimos cargar este panel correctamente.</h1>
            <p className="mt-4 text-sm leading-7 text-[#6a6056]">Mostramos este estado para evitar una pantalla en blanco. Puedes recargar o volver a intentar el acceso.</p>
            <div className="mt-6 rounded-[1.3rem] bg-[#fbf9f5] p-4 text-sm text-[#5f554c]">
              <strong>Detalle:</strong> {this.state.errorMessage}
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <button type="button" onClick={() => window.location.reload()} className="rounded-full bg-[#8c7a6b] px-5 py-3 text-sm text-white">Recargar</button>
              <a href="/admin/sales" className="rounded-full border border-[#d8cfc1] px-5 py-3 text-sm text-[#2d2925]">Volver al panel</a>
            </div>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}